// Hover-only legend explaining the deterministic bet tags returned by
// the backend (`services/bet_tags.py`). Renders a tiny info pill that
// expands into a neon tooltip on hover. Pure CSS, no portals.
//
// Colors and icons mirror exactly what BetTag.jsx renders so the legend
// stays the source of truth in one glance.

import { Info } from "lucide-react";

const TAGS = [
  {
    tag: "VALUE",
    icon: "🎯",
    color: "#10B981",
    desc: "La quota paga più del giusto: edge ≥ 5% sul Pinnacle de-viggato, probabilità ≥ 50%, affidabilità ≥ 50/100. È la value bet standard.",
  },
  {
    tag: "PREMIUM",
    icon: "💎",
    color: "#22D3EE",
    desc: "Come VALUE, ma con edge eccezionale (≥ 12%). Opportunità rara — il book sta sbagliando di parecchio.",
  },
  {
    tag: "TRAP",
    icon: "⚠️",
    color: "#EF4444",
    desc: "Probabilità alta (≥ 65%) ma quota già spremuta dal book (edge ≤ 2%). ROI positivo statisticamente improbabile: meglio evitare.",
  },
];

export default function BetTagsLegend() {
  return (
    <div
      data-testid="bet-tags-legend"
      style={{ position: "relative", display: "inline-flex" }}
      className="bc-legend-wrap"
    >
      <button
        type="button"
        data-testid="bet-tags-legend-trigger"
        aria-label="Legenda flag scommesse"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          padding: "0.18rem 0.5rem",
          background: "var(--bc-panel-elev, var(--bc-panel-elev, rgba(255,255,255,0.03)))",
          border: "1px solid var(--bc-border, rgba(255,255,255,0.1))",
          color: "rgba(255,255,255,0.55)",
          fontFamily: "'Barlow Condensed',sans-serif",
          fontSize: "0.62rem",
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          fontWeight: 700,
          cursor: "help",
          lineHeight: 1,
        }}
      >
        <Info size={10} />
        Legenda
      </button>

      <div
        className="bc-legend-pop"
        role="tooltip"
        style={{
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          width: 300,
          background: "#0B0B0E",
          border: "1px solid rgba(255,255,255,0.14)",
          padding: "0.85rem",
          zIndex: 60,
          boxShadow: "0 12px 40px -8px rgba(0,0,0,0.7), 0 0 1px var(--bc-border, rgba(255,255,255,0.07))",
          pointerEvents: "none",
          opacity: 0,
          transform: "translateY(-4px)",
          transition: "opacity 140ms ease, transform 140ms ease",
        }}
      >
        <div
          style={{
            fontFamily: "'Barlow Condensed',sans-serif",
            fontSize: "0.7rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.45)",
            marginBottom: "0.6rem",
          }}
        >
          Cosa significano i flag
        </div>
        {TAGS.map((t) => (
          <div
            key={t.tag}
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              gap: "0.55rem",
              alignItems: "start",
              padding: "0.4rem 0",
              borderTop: "1px solid var(--bc-border, rgba(255,255,255,0.07))",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                padding: "0.18rem 0.45rem",
                background: `color-mix(in srgb, ${t.color} 14%, #0B0B0E)`,
                border: `1px solid ${t.color}`,
                color: t.color,
                fontFamily: "'Barlow Condensed',sans-serif",
                fontSize: "0.6rem",
                fontWeight: 800,
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                lineHeight: 1,
                whiteSpace: "nowrap",
                boxShadow: `0 0 10px -4px ${t.color}`,
              }}
            >
              <span aria-hidden="true">{t.icon}</span>
              {t.tag}
            </span>
            <span
              style={{
                color: "rgba(255,255,255,0.72)",
                fontSize: "0.72rem",
                lineHeight: 1.45,
              }}
            >
              {t.desc}
            </span>
          </div>
        ))}
      </div>

      <style>{`
        .bc-legend-wrap:hover .bc-legend-pop,
        .bc-legend-wrap:focus-within .bc-legend-pop {
          opacity: 1 !important;
          transform: translateY(0) !important;
          pointer-events: auto !important;
        }
      `}</style>
    </div>
  );
}
